import { type MCPServerInfo } from '../../types';

const SlackRemoteServer: MCPServerInfo = {
  serverId: 'SLACK_REMOTE',
  name: 'Slack',
  slug: 'slack-remote',
  description: 'Slack Remote MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.slack.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
  // authConfig: {
  //   supportedScopes: [
  //     'search:read.public',
  //     'search:read.private',
  //     'search:read.mpim',
  //     'search:read.im',
  //     'search:read.files',
  //     'files:read',
  //     'emoji:read',
  //     'search:read.users',
  //     'chat:write',
  //     'channels:history',
  //     'groups:history',
  //     'mpim:history',
  //     'im:history',
  //     'channels:write',
  //     'groups:write',
  //     'im:write',
  //     'mpim:write',
  //     'reactions:write',
  //     'canvases:read',
  //     'canvases:write',
  //     'users:read',
  //     'users:read.email',
  //     'channels:read',
  //     'groups:read',
  //     'mpim:read'
  //   ],
  //   scopeDelimiter: ',',
  //   creds: {
  //     clientId: {
  //       type: 'string',
  //       sensitive: false,
  //       envKey: 'SLACK_CLIENT_ID'
  //     },
  //     clientSecret: {
  //       type: 'string',
  //       sensitive: true,
  //       envKey: 'SLACK_CLIENT_SECRET'
  //     }
  //   }
  // }
};

export default SlackRemoteServer;
